import { useQuery } from '@tanstack/react-query';
import { useAtomValue } from 'jotai/react';
import { z } from 'zod';

import { reactQueryKeys } from '@/config/react-query';
import { useProvider } from '@/hooks/use-provider';
import { authenticatedAtom } from '@/lib/store';
import { PROVIDERS, omnihitAuthRefreshFetch } from '@/providers';

const CodWebResponseSchema = z.object({
  codWeb: z.string().min(1),
});

export const getCodWeb = async () => {
  const response = await omnihitAuthRefreshFetch('/api/cod-web');
  const { codWeb } = CodWebResponseSchema.parse(response.body);
  return codWeb;
};

export const useCodWeb = () => {
  const [provider] = useProvider();
  const isAuthenticated = useAtomValue(authenticatedAtom);

  return useQuery({
    queryKey: [reactQueryKeys.codWeb],
    queryFn: () => getCodWeb(),
    enabled: provider.id !== PROVIDERS.SALESFORCE && isAuthenticated,
    retry: true,
    staleTime: Infinity,
  });
};
